<template>
  <div>

    <el-dialog
      :visible.sync="showSaveVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="30%">
      <span>是否保存{{ dept.name }} ？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSaveVisible = false" type="info" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="save" :loading="sureLoading">确 定</el-button>
      </span>
    </el-dialog>

    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-weight: bolder;float: left">新增机构</span>
        </div>
        <div class="text item">
          <el-form
            label-position="top"
            :model="dept"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            class="demo-ruleForm">
            <el-row>
              <el-col :span="colSpan" :offset="colSpanOffSet">
                <el-form-item label="机构名称" :size="inputFromSize" prop="name">
                  <el-input v-model="dept.name" placeholder="请输入机构名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="colSpan" :offset="colSpanOffSet+1">
                <el-form-item label="上级机构" :size="inputFromSize" prop="parentIds">
                  <yl-cascader
                    placeholder="试试搜索：北京，或者选择"
                    ref="deptCascader"
                    style="display: block"
                    :checkStrictly="true"
                    v-model="dept.parentIds"
                    :show-all-levels="false"
                    :props="{ checkStrictly: true }"
                    :options="deptData"
                    @change="handleChange"
                    clearable
                    filterable>
                  </yl-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="22" :offset="1">
                <el-form-item label="机构描述">
                  <el-input type="textarea" maxlength="500" rows="6" show-word-limit v-model="dept.intro"></el-input>
                </el-form-item>
              </el-col>
            </el-row>


            <el-form-item>
              <div style="text-align: center">
                <common-button type="cancel" image @click="goBack" v-if="!componentFlag">返回</common-button>
                <common-button type="primary" image @click="triggerChecked('ruleForm')" :disabled="!deptPower"
                           :loading="sureLoading">
                  保存
                </common-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <el-form>

        </el-form>
      </el-card>
    </div>
    <!--    <div>-->
    <!--      <SectionInfo/>-->
    <!--    </div>-->
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import {Message} from "element-ui";
import {mapState} from "vuex";
import SectionInfo from '@/components/section/SectionInfo'
//引入formatDatetime方法
import {formatDatetime} from '@/utils/dateUtil'

export default {
  name: "Create",
  props:{
    componentFlag:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      deptPower: false,
      superPower: false,
      showSaveVisible: false,
      colSpan: 10,
      colSpanOffSet: 1,
      sureLoading: false,
      inputFromSize: "small",
      dept: {
        name: "",
        parentIds: [],
        intro: "",
      },
      rules: {
        name: [
          {required: true, message: '请输入机构名称', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 32 个字符之内', trigger: 'blur'}
        ],
        parentIds: [
          {required: true, message: '请选择上级机构', trigger: 'blur'}
        ],
      },
      deptData: []
    }
  },
  components: {
    SectionInfo,
  },

  mounted() {
    this.getAuth();
    this.$store.dispatch("loadingTreeDeptData")
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {

    })
  },

  watch: {
    userPower() {
      this.deptPower = this.$store.state.userPowerStore.deptPower
      this.superPower = this.$store.state.userPowerStore.superPower
    },
    treeDeptData(newVal) {
      this.deptData = newVal
    }
  },

  computed: mapState({
    userPower: state => state.userPowerStore.userPower,
    treeDeptData: state => state.departmentStore.treeDeptData,
  }),

  methods: {

    triggerChecked(formName) {
      let flag = false;
      //validate触发检验
      this.$refs[formName].validate((valid) => {
        flag = valid;
      });
      if (!flag) {
        return
      }
      this.showSaveVisible = true
    },
    handleChange(value) {
      this.$refs.deptCascader.dropDownVisible = false
      this.dept.parentId = value[value.length - 1]
    },

    getAuth() {
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("getUserPower").then(value => {
        //获取用户机构管理权限
        this.deptPower = this.$store.state.userPowerStore.deptPower
        this.superPower = this.$store.state.userPowerStore.superPower
      })
    },

    reset() {
      this.dept = this.$options.data().dept
    },

    //保存新增机构的信息
    save() {

      this.sureLoading = true
      let obj = {
        token: cookie.getCookie('token'),
        data: {
          name: this.dept.name,
          parentId: this.dept.parentId,
          intro: this.dept.intro,
        }
      }

      http.post(window.config.api.baseUrl + '/eims-api/department/create', obj).then(value => {
        if (value.data.code === '00000') {
          Message.success({message: "机构添加成功", showClose: true})

          this.$store.dispatch("loadingTreeDeptData")
          let dept = value.data.data.department
          dept.createTm = formatDatetime(dept.createTm, 'yyyy-MM-dd \n hh:mm:ss')
          dept.lastModTm = formatDatetime(dept.lastModTm, 'yyyy-MM-dd \n hh:mm:ss')
          //将数据添加返回的当前的数据页
          this.$store.state.departmentStore.deptListData.push(dept)
          this.reset()
          if (!this.componentFlag) {
            this.$router.replace({
              path: '/organization/list'
            })
          }
        }
      }).finally(() => {
        this.sureLoading = false
        this.showSaveVisible = false
      })
    },

    //返回上一页
    goBack() {
      this.$router.back()
    },


  }
}
</script>


<style scoped>

.text {
  font-size: 14px;
}

.item {
  text-align: left;
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 100%;
  border-radius: 10px
}
</style>




// WEBPACK FOOTER //
// src/pages/dept/Create.vue